import { InvoiceDisplayStatusV2 } from 'anchor-scout-common/types';
export const SHARED_RECEIPT_ELIGIBLE_STATUSES = new Set([
    InvoiceDisplayStatusV2.Paid
]);
// Statuses that must never offer a receipt even when the invoice was previously paid — the payment
// was either reverted (unmark paid externally → Overdue) or invalidated (Void), or never happened.
// These override the originalPaymentTimestamp gate. (ANCR-3168 / ANCR-3173)
export const SHARED_RECEIPT_INELIGIBLE_STATUSES = new Set([
    InvoiceDisplayStatusV2.Issued,
    InvoiceDisplayStatusV2.Pending,
    InvoiceDisplayStatusV2.Overdue,
    InvoiceDisplayStatusV2.Processing,
    InvoiceDisplayStatusV2.Voided
]);
export const isReceiptEligible = (displayStatus, originalPaymentTimestamp)=>{
    if (displayStatus != null && SHARED_RECEIPT_INELIGIBLE_STATUSES.has(displayStatus)) return false;
    return displayStatus != null && SHARED_RECEIPT_ELIGIBLE_STATUSES.has(displayStatus) || originalPaymentTimestamp != null;
};
